export enum Element {
  RANDOM = 100,
  FIRE = 0,
  EARTH = 1,
  LIGHTNING = 2,
  WATER = 3,
}
